module.exports = require('./helpers/bundle-url').getBundleURL('3u1yT') + "logo-dark.eefe0b7f.svg";